import { render, staticRenderFns } from "./hawa.editor.vue?vue&type=template&id=6a50ed23&scoped=true&"
import script from "./hawa.editor.vue?vue&type=script&lang=ts&"
export * from "./hawa.editor.vue?vue&type=script&lang=ts&"
import style0 from "./hawa.editor.vue?vue&type=style&index=0&id=6a50ed23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50ed23",
  null
  
)

export default component.exports